import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    Typography,
    TablePagination,
    TableHead,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Divider } from "antd";
import React, { useState } from "react";

const RemissionFactList = ({ remissionsFact, displayPDF }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [expandedRow, setExpandedRow] = useState(null);
    const [selectedClientRemissions, setSelectedClientRemissions] = useState([]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleClickRow = (clientName) => {
        const clientRemissions = remissionsFact[clientName] || [];
        setSelectedClientRemissions(clientRemissions.map((remission) => remission));
        setExpandedRow(expandedRow === clientName ? null : clientName);
    };


    return (
        <>
            <div style={{ display: 'flex' }}>
                <div>
                    <Typography variant="h6" component="h6" style={{ marginTop: '10px' }}>
                        Historial de Remisiones
                    </Typography>
                </div>

            </div>

            <Divider />

            <TableContainer component={Paper} elevation={3} style={{ maxHeight: "400px", overflowY: "auto" }}>
                <Table sx={{ minWidth: 650 }}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{backgroundColor:'#f2f2f2'}}>REMISIONES FACTURADAS </TableCell>
                    </TableRow>
                </TableHead>
                    <TableBody>
                        {Object.keys(remissionsFact).map((clientName) => (
                            <React.Fragment key={clientName}>
                                <TableRow onClick={() => handleClickRow(clientName)}>
                                    <TableCell>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", margin: "0px -5px" }}>
                                            <span>{clientName}</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                                {expandedRow === clientName && (
                                    <TableRow>
                                        <TableCell colSpan={1} style={{backgroundColor:'#f2f2f2'}}>
                                            {selectedClientRemissions.map((remission) => (
                                                <div key={remission.id}>
                                                    <b>Remision ID: </b>{remission.id}
                                                    <IconButton
                                                        style={{ marginRight: '10px' }}
                                                        color='primary'
                                                        aria-label='pdf'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            displayPDF(remission);
                                                        }}
                                                    >
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                    <b>(Fecha: </b>{remission.date ? remission.date : 'Sin Fecha'} <b>)</b>
                                                </div>
                                            ))}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        ))}
                    </TableBody>

                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={Object.keys(remissionsFact).length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </>
    )
}

export default RemissionFactList;
